import React, { forwardRef, useCallback, useState } from 'react';
import TextField from '@polestar/component-warehouse-react/components/text-field/TextField';
import * as Icons from '@polestar/component-warehouse-react/tokens/icons/Icons';
import { FormFieldIconButton } from '@polestar/component-warehouse-react/components/form-field/FormField';
const PasswordField = forwardRef(({ ariaClearLabel = 'Clear', ...props }, ref) => {
    const [visible, setVisible] = useState(false);
    const toggleType = useCallback(() => {
        setVisible((oldVisible) => !oldVisible);
    }, []);
    const trailing = (React.createElement(FormFieldIconButton, { "aria-label": ariaClearLabel, onClick: toggleType, disabled: props.disabled, icon: visible ? Icons.invisible : Icons.visible, pairedWithText: false }));
    return (React.createElement(TextField, { autoComplete: "current-password", ...props, ref: ref, trailing: trailing, type: visible ? 'text' : 'password' }));
});
PasswordField.displayName = 'PasswordField';
export default PasswordField;
